import React, { useState, useEffect } from 'react';
import './form.css';
import star from '../assets/star.svg';
import TitleBlock from '../components/common/title';
import { useTranslation } from 'react-i18next';
import { supabase } from './../supabase';

const Form1 = () => {
  const { t } = useTranslation();

  // STATE
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [tickets, setTickets] = useState('');

  // FETCH EVENTS
  useEffect(() => {
    const getAllEvents = async () => {
      const { data, error } = await supabase
        .from('event')
        .select('*');

      if (error) {
        console.log("Supabase error:", error);
        return;
      }

      setEvents(data);
    };

    getAllEvents();
  }, []);

  // SUBMITBOOKING
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedEvent) {
      alert("Please select an event");
      return;
    }

    const selectedEventData = events.find(
      (event) => event.id == selectedEvent
    );

    const { error } = await supabase
      .from('booking')
      .insert([
        {
          event_id: selectedEvent,
          event_name: selectedEventData?.title,
          phone: phone,
          email: email,
          tickets_number: tickets,
        },
      ]);

    if (error) {
      console.log("Insert error:", error);
      alert("Error creating booking");
      return;
    }

    alert("Booking created successfully!");

    // RESET FORM
    setSelectedEvent('');
    setPhone('');
    setEmail('');
    setTickets('');
  };

  return (
    <form className='form1' onSubmit={handleSubmit}>
      <div className="formLeft">
        <TitleBlock
          img={star}
          class="title1"
          heading={t('home.book.heading')}
          subheading={t('home.book.subheading')}
        />

        {/* EVENT SELECT */}
        <div className='selectoption'>
          <select
            placeholder={t('home.book.event')}
           
            value={selectedEvent}
            onChange={(e) => setSelectedEvent(e.target.value)}
          >
            <option value="">Select Event</option>
            {events.map((event) => (
              <option key={event.id} value={event.id}>
                {event.title}
              </option>
            ))}
          </select>
        </div>
<div className="chipsFlex">
             {/* PHONE */}
        <input
          type="text"
          placeholder={t('home.book.phone')}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />

        {/* EMAIL */}
        <input
          type="email"
          placeholder={t('home.book.email')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {/* TICKETS */}
        <input
          type="number"
          placeholder={t('home.book.tickets')}
          value={tickets}
          onChange={(e) => setTickets(e.target.value)}
        />
        </div>
       
        <button type='submit' className='btn1 btn4'>
          {t('home.book.cta')}
        </button>
      </div>
    </form>
  );
};

export default Form1;